import {CONFIG_TYPE} from './types';

export const getConfig = data => ({
  type: CONFIG_TYPE,
  payload: data,
});
